import React from 'react';
import styles from './Home.module.scss';
import { RiselioDescription } from '../../components/riselio-description/RiselioDescription';
import { DownloadRiselio } from '../../components/download-riselio/DownloadRiselio';

export function Home() {
    return (
        <div>
            <div className={styles.Home__banner}>
                <div className="home row">
                    <div className="col-sm-12 col-md-6 col-xl-5">
                        <div className={styles.Left__side}>
                            <div className={styles.Tagline}>
                                <h1>Dapatkan Penghasilan Ekstra Tanpa Modal!</h1>
                                <br />
                                <span>Bergabung dengan ribuan seller lainnya untuk mendapatkan penghasilan tambahan
                            hingga 5 juta rupiah tiap bulan!</span> <strong>Tanpa modal & resiko!</strong>
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.application.riselio" target="_blank" rel="noopener noreferrer">
                                <img className="btn-google-play undragable" alt="Google Play" src="./assets/google-play.png" />
                            </a>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-xl-7">
                        <div className={styles.Right__side}>
                            <img className={styles.Image__shop} alt="Belanja Riselio" src="./assets/shopping-screen-riselio.png" />
                        </div>
                    </div>
                </div>
            </div>
            <RiselioDescription />
            <DownloadRiselio />
        </div>
    );
}

